import React from "react";

function Collapse({
  children,
  title,
  showSidebar,
  setShow,
  isOpen,
  setShowCancelButton,
}) {
  return (
    <div
      onClick={() => {
        setShow(false);
        setShowCancelButton(false);
        // document.body.style.overflow = "hidden";
      }}
      className={`overflow-hidden ${
        isOpen && title === "report" ? "h-[182px]" : isOpen && title !== "dashboard" ? "h-32" : "h-0"
      } ${showSidebar ? "w-fit" : "w-[95%]"} mx-auto transition-all duration-300 ease-out rounded-lg bg-slate-800/50`}
    >
      {children}
    </div>
  );
}

export default Collapse;
